import React from 'react';
// constants
import { IconLightningBolt } from '@/constants/icons/svg';
import { DlsFontVariants } from '@/constants/DLSTokens';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// styles
import styles from './Nudge.module.scss';
const Nudge = ({ text }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.icon },
            React.createElement(IconLightningBolt, null)),
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, customColor: {
                light: tokens.colors.violet1,
                dark: tokens.colors.violet1,
            }, className: styles.text }, text)));
};
export default React.memo(Nudge);
